import { InferSelectModel } from 'drizzle-orm';
import { entitlementsTable } from '@/api-server/services/db/schema/auth';

export type Entitlements = Omit<
  InferSelectModel<typeof entitlementsTable>,
  'user_id' | 'created_at' | 'updated_at'
>;

export const ADMIN_ENTITLEMENTS = [
  'can_demo',
  'can_manage_content',
  'can_manage_prompts',
  'can_manage_badges',
  'can_replay_logs',
  'can_view_reports',
  'can_manage_users',
];

export const DEFAULT_ENTITLEMENTS = {
  can_demo: false,
  can_manage_content: false,
  can_manage_prompts: false,
  can_manage_badges: false,
  can_replay_logs: false,
  can_view_reports: false,
  can_manage_users: false,
  can_view_user_reports: false,
};

export const hasAdminEntitlement = (entitlements: Entitlements) =>
  Object.entries(entitlements).some(([key, value]) => ADMIN_ENTITLEMENTS.includes(key) && value);
